
import { computed, defineComponent, ref, watch, PropType } from 'vue'
import {
  ToastVariantsMap,
  ToastVariantsEnum,
  ToastVariantsArray,
} from '../../components/Toast/BToast.types'

export default defineComponent({
  name: 'BToast',
  props: {
    isToastOpen: {
      type: Boolean,
      default: false,
    },
    toastDuration: {
      type: Number,
      default: 3000,
    },
    variant: {
      type: String as PropType<ToastVariantsEnum>,
      required: false,
      default: ToastVariantsEnum.PRIMARY,
      validator: (prop: ToastVariantsEnum) => ToastVariantsArray.includes(prop)
    },
  },
  setup(props, { emit }) {
    const isActive = ref(props.isToastOpen)

    const classes = computed(() => ToastVariantsMap[props.variant])

    watch(() => props.isToastOpen, newValue => {
      isActive.value = newValue
      if (isActive.value) {
        setTimeout(() => closeAlert(), props.toastDuration)
      }
    })

    function closeAlert() {
      isActive.value = false
      emit('close', false)
    }

    return {
      isActive,
      closeAlert,
      classes,
    }
  },
})
